import React from "react";
import "./Footer.css";

const COPYRIGHT_START_YEAR = 2022;

const Footer = () => {
  const endYear = new Date().getFullYear();
  const yearLabel =
    endYear > COPYRIGHT_START_YEAR
      ? `${COPYRIGHT_START_YEAR}–${endYear}`
      : String(COPYRIGHT_START_YEAR);

  return (
    <footer className="footer justo-app-footer" role="contentinfo">
      <div className="justo-app-footer__bar">
        <div className="justo-app-footer__inner">
          <p className="justo-app-footer__copy">
            <span className="justo-app-footer__mark" aria-hidden="true">
              ©
            </span>
            <span className="justo-app-footer__years">{yearLabel}</span>
            <span className="justo-app-footer__dot" aria-hidden="true">
              ·
            </span>
            <span className="justo-app-footer__brand">Justo</span>
            <span className="justo-app-footer__dot" aria-hidden="true">
              ·
            </span>
            <span className="justo-app-footer__rights">All rights reserved</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
